import { Tooltip } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { display } from "@material-ui/system";
import classnames from "classnames";
import React, { useState } from "react";

import { RelodeTheme, Text } from "..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            toggleSwitch: {
                width: 300,
                height: 35,
                borderRadius: 30,
                backgroundColor: theme.relode.colors.chip.unselected.main,

                display: "inline-block",
                verticalAlign: "middle",
                cursor: "pointer",
                position: "relative",
                marginRight: 20,
                //paddingTop: 7,
                //paddingRight: 6,
                boxSizing: "border-box",
                userSelect: "none",
                "&::after": {
                    transition: "left .2s ease",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    left: 0,
                    display: "block",
                    // eslint-disable-next-line quotes
                    content: '""',
                    background: theme.relode.colors.chip.selected.light,
                    width: 154,
                    height: 35,
                    borderRadius: 30,
                    boxShadow: "4px 0px 8px -4px #acacac",
                },
                "&:hover": {
                    "&::after": {
                        //backgroundColor: theme.relode.colors.chip.selected.main,
                    },
                    backgroundColor: "#E5E3E8",
                    transition: theme.transitions.create("background-color", {
                        duration: theme.transitions.duration.enteringScreen,
                        easing: theme.transitions.easing.easeIn,
                    }),
                },
                "& > span": {
                    color: theme.palette.common.black,
                    width: "50%",
                    display: "inline-block",
                    textAlign: "center",
                    position: "relative",
                    zIndex: 5,
                    lineHeight: "35px",
                    borderRadius: "32px",
                    height: "100%",
                },

                "&.checked": {
                    "&::after": {
                        left: "49%",
                        boxShadow: "-4px 0px 8px -4px #acacac",
                    },
                },
            },
        }),
    { name: "toggleSwitch" }
);

export type ToggleStyleKeys = "root" | "label" | "toggleSwitch";
export type ToggleStyles = Partial<Record<ToggleStyleKeys, string>>;

export interface ToggleProps {
    toggleAction: () => void;
    firstOption: string;
    secondOption: string;
    classes?: ToggleStyles;
}

export const ToggleSwitch = (props: ToggleProps) => {
    const [isFirstOptionSelected, setOption] = useState(true);

    const handleChange = () => {
        isFirstOptionSelected === true ? setOption(false) : setOption(true);
        props.toggleAction();
    };

    const classes = useStyles(props);

    return (
        <label
            className={
                isFirstOptionSelected
                    ? classes.toggleSwitch
                    : classnames(classes.toggleSwitch, "checked")
            }
        >
            <input
                type="checkbox"
                checked={isFirstOptionSelected}
                onChange={handleChange}
                hidden
            />
            <Tooltip placement="bottom" title={`view ${props.firstOption}`}>
                <Text variant="body1" component="span">
                    {props.firstOption}
                </Text>
            </Tooltip>
            <Tooltip placement="bottom" title={`view ${props.secondOption}`}>
                <Text variant="body1" component="span">
                    {props.secondOption}
                </Text>
            </Tooltip>
        </label>
    );
};
